/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : RenderAsKeyValue.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box, Typography } from "@mui/material";
import React from "react";
import { componentStyle } from "../../../../config/appTheme";

function RenderAsKeyValue({ keyValues }) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      {Object.entries(keyValues).map(([key, value], index) => (
        <Box key={index} sx={{ display: "inline-flex", gap: 1 }}>
          <Typography sx={{ ...componentStyle.font.keyValueHeader }}>
            {key}:
          </Typography>
          <Typography sx={{ ...componentStyle.font.keyValueContent }}>
            {value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}

export default RenderAsKeyValue;
